import { useTheme } from "@emotion/react";
import React from "react";

function BassIcon() {
  const theme = useTheme();
  return (
    <svg
      width="47"
      height="38"
      viewBox="0 0 47 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6_1931)">
        <path
          d="M19.466 20.1415C19.466 20.1415 18.1866 20.4261 17.9402 18.8932C17.6938 17.3603 20.6892 16.1798 19.7579 15.4279C18.8267 14.6761 16.8236 14.998 14.4113 17.9669C11.999 20.9357 10.5486 21.0151 8.2022 21.3123C5.85581 21.6094 -0.120144 23.8987 4.85204 31.2896C9.82423 38.6805 13.059 35.6696 15.8435 31.072C18.6299 26.4731 20.0113 30.0315 22.7149 26.7697C25.4204 23.5065 21.67 24.9716 21.67 24.9716C21.67 24.9716 19.1149 26.3702 18.77 23.6221L19.466 20.1415Z"
          fill="#282827"
        />
        <path
          d="M43.4256 7.38499C42.8416 6.51702 42.181 6.81745 42.181 6.81745C42.181 6.81745 34.9825 8.66541 35.0857 9.02803C35.1888 9.39065 34.9273 9.6342 34.9273 9.6342L15.8904 22.4411L17.3209 24.5676L36.3578 11.7606C37.3438 10.9063 38.5668 11.5353 38.5668 11.5353C38.5668 11.5353 41.0203 9.14419 41.3361 8.87885C41.6498 8.61491 42.17 9.17893 42.5901 9.17552C43.0088 9.17008 44.0108 8.25499 43.4269 7.38701L43.4256 7.38499Z"
          fill="white"
        />
        <path
          d="M11.5113 28.952L9.54993 26.0365L7.81555 27.2033L9.77693 30.1188L11.5113 28.952Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_1931">
          <rect
            width="14.6162"
            height="45.3509"
            fill="white"
            transform="translate(38.4575) rotate(56.0696)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BassIcon;
